.list {
  display: flex;
  flex-direction: column;
  margin: 0;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--border);
  font-size: var(--font-size-13);
}

.row:last-child {
  border-bottom: 0;
}

.purpose {
  color: var(--text);
}

.keys {
  margin: 0;
}

/* The mockup's rows: 48px, the purpose at 13px and the caps a 4px apart. */
.row {
  min-block-size: 48px;
}

.keys {
  display: flex;
  gap: var(--space-1);
}
